import React, { useState, useEffect } from 'react';
import { Modal, ModalBody } from '@windmill/react-ui';

const TripadvanceApproval = ({
	isOpen,
	onClose,
	title = 'Trip Advance Approval',
	handleSubmit, // This function should accept (selectedAmounts, remainingAmount, selectedIds)
	billAmount,
	data = [],
	customClass = '',
}) => {
	const [selectedAmounts, setSelectedAmounts] = useState([]);
	const [selectedIds, setSelectedIds] = useState([]); // New state to hold checkbox IDs
	const [totalAmount, setTotalAmount] = useState(0);
	const [remarks, setRemarks] = useState({});
	useEffect(() => {
		if (data && isOpen) {
			setSelectedAmounts([]);
			setSelectedIds([]);
			setTotalAmount(0);
		}
	}, [data, isOpen]);
	const handleRemarkChange = (id, value) => {
		setRemarks((prev) => ({
			...prev,
			[id]: value,
		}));
	};
	// Update the handler to accept the id parameter as well.
	const handleCheckboxChange = (amount, id, isChecked) => {
		const numericAmount = parseFloat(amount) || 0;

		if (isChecked) {
			setSelectedAmounts((prev) => [...prev, numericAmount]);
			setSelectedIds((prev) => [...prev, id]);
			setTotalAmount((prev) => prev + numericAmount);
		} else {
			setSelectedAmounts((prev) => prev.filter((a) => a !== numericAmount));
			setSelectedIds((prev) => prev.filter((selectedId) => selectedId !== id));
			setTotalAmount((prev) => prev - numericAmount);
		}
	};

	// Calculate the remaining amount
	const remainingAmount = billAmount - Math.abs(totalAmount);

	return (
		<Modal
			isOpen={isOpen}
			onClose={() => {
				onClose();
				setSelectedAmounts([]); // Reset selected amounts
				setSelectedIds([]); // Reset selected IDs
				setTotalAmount(0); // Reset total amount
			}}
			className={`relative bg-white pb-0 p-4 w-1/3 rounded-lg ${customClass}`}
			aria-labelledby="modal-title"
		>
			<span id="modal-title" className="flex text-2xl text-green-500">
				{title}
			</span>

			<ModalBody className="!mb-0 text-center custom-modal pt-3 pb-4">
				{data && data.length > 0 ? (
					<div className="overflow-x-auto mt-4">
						<table className="table-auto w-full border-collapse border border-gray-300">
							<thead>
								<tr className="bg-gray-200">
									<th className="border border-gray-300 px-4 py-2">Select</th>
									<th className="border border-gray-300 px-4 py-2">S.No</th>
									<th className="border border-gray-300 px-4 py-2">
										Start Date
									</th>
									<th className="border border-gray-300 px-4 py-2">ID</th>
									<th className="border border-gray-300 px-4 py-2">
										Reference No
									</th>
									<th className="border border-gray-300 px-4 py-2">
										Adjusted Amount
									</th>
								</tr>
							</thead>
							<tbody>
								{data.map((item, index) => (
									<tr key={index} className="hover:bg-gray-100">
										<td className="border border-gray-300 px-4 py-2">
											<input
												type="checkbox"
												autoComplete="off"
												onChange={(e) =>
													handleCheckboxChange(
														item.adjust_amount,
														item.id,
														e.target.checked
													)
												}
											/>
										</td>
										<td className="border border-gray-300 px-4 py-2">
											{index + 1}
										</td>
										<td className="border border-gray-300 px-4 py-2">
											{item.va_start_date
												? new Date(item.va_start_date).toLocaleDateString()
												: 'N/A'}
										</td>
										<td className="border border-gray-300 px-4 py-2">
											{item.id || 'N/A'}
										</td>
										<td className="border border-gray-300 px-4 py-2">
											{item.ref_no || 'N/A'}
										</td>
										<td className="border border-gray-300 px-4 py-2">
											{item.adjust_amount || 'N/A'}
										</td>
										<td className="border border-gray-300 px-4 py-2">
											<input
												type="text"
												placeholder="Enter remark"
												className="border px-2 py-1 w-full"
												value={remarks[item.id] || ''}
												autoComplete="off"
												onChange={(e) =>
													handleRemarkChange(item.id, e.target.value)
												}
											/>
										</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				) : (
					<p className="text-gray-500 mt-4"></p>
				)}
				<div className="mt-4 flex space-x-4">
					{/* Bill Amount Input Box */}
					<div className="flex-1">
						<label htmlFor="billAmount" className="block text-gray-700">
							Request Amount:
						</label>
						<input
							id="billAmount"
							type="text"
							value={billAmount}
							readOnly
							className="input w-full border border-gray-300 rounded-md p-2 mt-2"
						/>
					</div>
					{data && data.length > 0 && (
						<div className="flex-1">
							<label htmlFor="totalAmount" className="block text-gray-700">
								Adjusted Amount:
							</label>
							<input
								id="totalAmount"
								type="text"
								value={Math.abs(totalAmount)}
								readOnly
								className="input w-full border border-gray-300 rounded-md p-2 mt-2"
							/>
						</div>
					)}

					{/* Remaining Amount Input Box */}
					<div className="flex-1">
						<label htmlFor="remainingAmount" className="block text-gray-700">
							Remaining Amount:
						</label>
						<input
							id="remainingAmount"
							type="text"
							value={remainingAmount}
							readOnly
							className="input w-full border border-gray-300 rounded-md p-2 mt-2"
						/>
					</div>
				</div>

				<div className="modal-actions flex justify-center space-x-4 mt-4">
					<button
						onClick={() =>
							handleSubmit(
								selectedIds,
								remainingAmount,
								selectedAmounts,
								remarks
							)
						}
						className="btn btn-primary px-4 py-2 bg-green-500 text-white rounded-md"
					>
						Submit
					</button>
					<button
						onClick={onClose}
						className="btn btn-secondary px-4 py-2 bg-gray-300 text-gray-700 rounded-md"
					>
						Cancel
					</button>
				</div>
			</ModalBody>
		</Modal>
	);
};

export default TripadvanceApproval;
